import { ImageVariants, Maybe } from '@phoenix/team-m/my-tool-shed/frontend/domain/generated/graphql';

export const getOptimizedImage = (variants?: Maybe<ImageVariants>, mimeType = 'image/webp') =>
  variants?.optimizedImages.find((image) => image?.mimeType === mimeType);
